import React, { useState, useRef } from 'react';
import ReportIcon from '@material-ui/icons/Report';
import TextField from '@material-ui/core/TextField';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
// import { connect } from 'react-redux';
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";
import no_user from '../images/no_user.png';
import saveImage from '../Services/saveImage';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    title: {
      fontSize: '18px',
    },
  }));

const UserCard = ({ name,role,message, image, dispatch}) => {
    const classes = useStyles();

    const userImageValue = useRef(null);
    const { message1, setMessage1,message2, setMessage2 } = message;
    const { jobTitle,setJobTitle } = role;
    const { userName,setUserName } = name;
    const { userImage,setUserImage} = image;
    const [inProgress, setInProgress] = useState(false);

    const uploadUserImage = async (uploadedFile) => {
        if(!uploadedFile){
            return
        };
        setInProgress(true);
        await saveImage(uploadedFile)
            .then(res => {
                if (res.image_url) {
                    setUserImage(res.image_url);
                    setInProgress(false)
                } else {
                    toast.error('Something went wrong');
                }
            })

    };

    return (
        <div className="snapboard-card">
            <div className="card-user-image">
                <Tooltip 
                    classes={{ tooltip: classes.title }}
                    title="This is the image of the person who will be displayed on the Snapboard. Please choose an image from your computer that has a square aspect ratio. The length and width of the image should be the same."
                >
                    <ReportIcon style={{ color: '#0d7cf5' }} />
                </Tooltip>
                {!inProgress ?
                    <div 
                        style={{ backgroundImage: `url(${!userImage ? no_user : userImage})`}}
                        className="div-img"
                    /> :
                    <CircularProgress />
                }

                <input
                    accept="image/*"
                    style={{ display: 'none'}}
                    id="upload-user-img"
                    type="file"
                    onChange={() => uploadUserImage(userImageValue.current.files[0])}
                    ref={userImageValue}
                />
                <label htmlFor="upload-user-img">
                    <IconButton aria-label="upload picture" component="span">
                        <EditOutlinedIcon />
                    </IconButton>
                </label>

            </div>

            <div className="card-user-info">
                <div className="user-info">
                    <div className="h4">
                        <h4 className="required">
                            NAME
                        </h4>
                        <Tooltip 
                            title="This is the name of the person who will be displayed on the Snapboard."
                            classes={{ tooltip: classes.title }}
                        >
                            <ReportIcon style={{ color: '#0d7cf5' }} />
                        </Tooltip>
                        
                    </div>

                    <TextField
                        id="outlined-basic1"
                        placeholder="Please enter your name here"
                        value={userName}
                        onChange={(e) => setUserName(e.currentTarget.value)}
                        variant="outlined"
                        size="small"
                        className="name-field"
                    />

                </div>
                <div className="user-info">
                <div className="h4">
                    <h4 className="required">
                        JOB TITLE
                    </h4>
                    {/* <Tooltip title="">
                        <ReportIcon style={{ color: '#0d7cf5' }} />
                    </Tooltip> */}
                </div>
                  
                    <TextField
                        id="outlined-basic2"
                        placeholder="Enter a title to appear below the profile picture"
                        variant="outlined"
                        size="small"
                        className="name-field"
                        multiline
                        value={jobTitle}
                        onChange={(e) => setJobTitle(e.currentTarget.value)}
                    />

                </div>

            </div>
            <div className="card-message">
                <Tooltip 
                    title="These are the messages that will be displayed on the Snapboard. You can keep the default text or change it to your liking."
                    classes={{ tooltip: classes.title }}
                >
                    <ReportIcon style={{ color: '#0d7cf5' }} />
                </Tooltip>
                <h4>
                    MESSAGE 1
                </h4>

                <TextField
                    id="outlined-multiline-static3"
                    multiline
                    rowsMax={4}
                    defaultValue={message1}
                    placeholder="You must provide message text here"
                    variant="outlined"
                    className="message-1-field"
                    size="small"
                    onChange={(e) => setMessage1(e.currentTarget.value)}
                />
            </div>

            <div className="card-message">
                <h4>
                    MESSAGE 2
                </h4>

                <TextField
                    id="outlined-multiline-static4"
                    multiline
                    size='small'
                    rowsMax={4}
                    defaultValue={message2}
                    placeholder="You must provide message text here"
                    variant="outlined"
                    className="message-2-field"
                    onChange={(e) => setMessage2(e.currentTarget.value)}
                />
            </div>
        </div>
    )
};  

export default UserCard;